export const FIXED_H = 61; // hauteur du Header fixe global
